import { EmptyState, NoDataIcon } from '@lmc/ui-kit'
import { NAMESPACE } from 'locale'
import { riskAssessmentReportConstants as translations } from 'locale/riskAssessmentReports'
import { useTranslation } from 'react-i18next'

const NoDataEmptyState = () => {
  const { t } = useTranslation(NAMESPACE.RISK_ASSESSMENT_REPORT)
  return (
    <EmptyState
      title={t(translations.EMPTY_STATE_NO_DATA)}
      description={t(translations.EMPTY_STATE_NO_DATA_DESCRIPTION)}
      icon={<NoDataIcon />}
    />
  )
}

export default NoDataEmptyState
